export default __webpack_public_path__ + "static/media/gallery_00.f3fafb80.jpg";